export const MULTIGROUPING_ENDPOINT = '/sportsbook-req/getMultiGroupingDataAjax';
export const MULTIGROUPING_MAIN = 'multi-grouping';
export const MULTIGROUPING_CONTENT_SECTION = `${MULTIGROUPING_MAIN}__content-section`;

